import { Navigate } from "react-router-dom";
import Students from "pages/Students";
import Properties from "pages/Properties";
import ForgotPassword from "pages/Forgot/ForgetPassword";
import Joinuser from "pages/JoinUser/JoinUser";
import StudentsDetails from "pages/StudentsDetails";
import ResetPassword from "pages/ResetPassword/ResetPassword";
import Signin from "pages/Signin/signin";
import UsersList from "pages/UsersList";
import Signup from "pages/Signup/Signup";
import SignupSuccess from "pages/Signup/Success";
import UserDetailsModal from "pages/UsersList/User/UserDetailsModal";
import PrivacyPolicy from "../Privacy/PrivacyPolicy";
import FormBuilder from "../pages/FormBuilder/FormBuilder";
import Form from "../pages/FormBuilder/Form";
import Application from "../pages/Applications";
import Universities from "../pages/Universitites";
import ApplicationDetails from "../pages/ApplicationsDetails";
import UserPreferences from "pages/UserPreferences";
import Courses from "../pages/Courses";
import Dashboards from "../pages/Dashboards";
import Dashboard from "../pages/Dashboards/Dashboard";
import DashboardCreate from "../pages/Dashboards/Create";
import DashboardEdit from "../pages/Dashboards/Edit"
import AIDashboard from "../pages/Dashboards/Dashboard1"
import CourseDetails from "../pages/CourseDetails";
import UniversityDetails from "../pages/UniversityDetails";
import Sources from "../pages/Sources";
import Channels from "../pages/Channel";
import SourceDetails from "../pages/SourceDetails";
import CompanyDetails from "../pages/CompanyDetails";
import ChannelDetails from "../pages/ChannelDetails";
import Companies from "../pages/Companies";
import Charts from "../pages/Charts/ECharts"
import Invoices from "pages/Invoices";
import InvoiceCreate from "pages/ChannelInvoices/InvoiceCreate";
import StudentsInvoices from "pages/StudentInvoices";
import StudentsInvoiceCreate from "pages/StudentInvoices/InvoiceCreate";
import Recommendations from "pages/Recommendations";
import Textract from "../Components/Common/Textract/textract";
import CustomForms from "../pages/Forms";
import CustomForm from "../pages/Forms/Form";
import CustomFormsBuilder from "../pages/Forms/FormBuilder";
import EditForm from "../pages/Forms/EditForm";
import Subagent from "../pages/SubAgents"
import SubagentDetails from "../pages/SubAgentDetails"
import SessionError from "../Components/Common/SessionError"
import Roles from "../pages/Roles/Index"
import Reports from "../pages/Reports"
import CreateReport from "../pages/Reports/Create"
import EditReport from "../pages/Reports/Edit";
import ViewReport from "../pages/Reports/View";
import BankDetails from "../pages/CompanyDetails/BankDetails"
import ChannelContractDetails from "../pages/ChannelDetails/ContractDetails"
import SubagentContractDetails from "../pages/SubAgentDetails/ContractDetails"
import InstitutesContractDetails from "../pages/UniversityDetails/ContractDetails"
import Products from "../pages/Products"
import ProductDetails from "../pages/ProductDetails";
import Templates from "../pages/Templates";
import TemplatesDetails from "../pages/TemplatesDetails";
import DealsDetails from "../pages/DealDetails";
import PricingModel from "pages/Pricing/PricingModel";
import Import from "../Components/Common/Import";
import MultipleSignin from "pages/MultipleSignIn/MultipleSignin";
import CommissionCreate from "Components/Common/CommissionCreate";
import InstituteCommissionList from "pages/UniversityDetails/ChannelFinanace/Rules";
import InstituteSubagentCommissionList from "pages/UniversityDetails/SubagentFinance/Rules";
import ChannelCommissionList from "pages/ChannelDetails/Finanace/Rules";
import SubagentCommissionList from "pages/SubAgentDetails/Finanace/Rules"
import AgentChangeForm from "pages/AuthLetters/StudentAgentChangeLetters";
import AuthorizationStudentForm from "pages/AuthLetters/StudentAuthorizationLetters";
import MigrationConfirmation from "pages/MigrationConfirmation/MigrationConfirmation";
import MeetingBooking from "pages/MeetingBooking";
import RecentImports from "pages/RecentImports";
import ShortList from 'pages/Students/Applications/Recommend/ShortListCourses/Recommend'
import CreateChannelInvoices from 'Components/Common/Invoices/InvoiceWizard'
import QuickCreateChannelInvoices from 'Components/Common/Invoices/QuickInvoice'
import Disputes from "pages/Disputes";
import Payments from "pages/Payments";
import Teams from "pages/Teams";
import OutlookSync from "pages/UserPreferences/Accounts/OutlookSync";
import CKEditor from 'Components/Common/Ckeditor'
import CompanyLetterHeadHeader from "Components/Common/LetterHead/CompanyLetterHeadHeader";
import Duplicates from 'Components/Common/ManageDuplicates';
import Audit from 'pages/Audit';
import AuditLogContainer from "pages/Audit/User/AuditLogContainer";
import Notifications from "pages/Notifications";
import Workspace from "pages/Workspace";
import Marketplace from "pages/Integrations/Details";
import Integrations from "pages/Integrations/Integrations";
import LeadCollectionSetup from "pages/Integrations/Setup";
import OAuthCallback from "pages/Integrations/Actions/OAuthCallback";
import Campaigns from "pages/Campaign";
import CampaignDetails from "pages/Campaign/Details";
import CampaignWizard from "pages/Campaign/CampaignWizard";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/dashboards", component: <Dashboards /> },
  { path: "/dashboards/create", component: <DashboardCreate /> },
  { path: "/dashboards/edit/:id", component: <DashboardEdit /> },
  { path: "/students", component: <Students /> },
  { path: "/roles", component: <Roles /> },
  { path: "/students/:id", component: <StudentsDetails /> },
  { path: "/fields", component: <Properties /> },
  { path: "/users", component: <UsersList /> },
  { path: "/teams", component: <Teams /> },
  { path: "/ckeditor", component: <CKEditor /> },
  { path: "/users/:id", component: <UserDetailsModal /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/form", component: <Form /> },
  { path: "/form-builder", component: <FormBuilder /> },
  { path: "/courses", component: <Courses /> },
  { path: "/courses/:id", component: <CourseDetails /> },
  { path: "/institutes", component: <Universities /> },
  { path: "/institutes/:id", component: <UniversityDetails /> },
  { path: "/applications", component: <Application /> },
  { path: "/sources", component: <Sources /> },
  { path: "/channels", component: <Channels /> },
  { path: "/applications/:id", component: <ApplicationDetails /> },
  { path: "/user-preferences/:id", component: <UserPreferences /> },
  { path: "/user-preferences/connect/microsoft", component: <OutlookSync /> },
  { path: "/sources/:id", component: <SourceDetails /> },
  { path: "/create-invoices/advance/channel/:id", component: <CreateChannelInvoices /> },
  { path: "/create-invoices/quick/channel/:id", component: <QuickCreateChannelInvoices /> },
  { path: "/products/:id", component: <ProductDetails /> },
  { path: "/channels/:id", component: <ChannelDetails /> },
  { path: "/charts", component: <Charts /> },
  { path: "/ai-dashborad", component: <AIDashboard /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/invoices", component: <Invoices /> },
  { path: "/channels/invoices/create-invoice", component: <InvoiceCreate /> },
  { path: "/students/invoices", component: <StudentsInvoices /> },
  { path: "/students/invoices/create-invoice", component: <StudentsInvoiceCreate /> },
  { path: "/companies", component: <Companies /> },
  { path: "/companies/:id", component: <CompanyDetails /> },
  { path: "/companies/:id/banks/:childId", component: <BankDetails /> },
  { path: "/channels/:id/contracts/:childId", component: <ChannelContractDetails /> },
  { path: "/subagents/:id/contracts/:childId", component: <SubagentContractDetails /> },
  { path: "/institutes/:id/contracts/:childId", component: <InstitutesContractDetails /> },
  { path: "/textract", component: <Textract /> },
  { path: "/forms", component: <CustomForms /> },
  { path: "/subagents", component: <Subagent /> },
  { path: "/products", component: <Products /> },
  { path: "/templates", component: <Templates /> },
  { path: "/templates/:id", component: <TemplatesDetails /> },
  { path: "/deals/:id", component: <DealsDetails /> },
  { path: "/subagents/:id", component: <SubagentDetails /> },
  { path: "/forms/custom-form-builder", component: <CustomFormsBuilder /> },
  { path: "/forms/edit/:tenantId/:id/", component: <EditForm /> },
  { path: "/forms/view/:tenantId/:id/", component: <EditForm /> },
  { path: "/reports", component: <Reports /> },
  { path: "/reports/create", component: <CreateReport /> },
  { path: "/reports/edit/:id", component: <EditReport /> },
  { path: "/reports/:id", component: <ViewReport /> },
  { path: "/import", component: <Import /> },
  { path: "/duplicates", component: <Duplicates /> },
  { path: "/recent-import", component: <RecentImports /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/students" />,
  },
  { path: "*", component: <Navigate to="/students" /> },
  { path: "/finance/:universityId/create", component: <CommissionCreate /> },
  { path: "/finance/:universityId/:financeId/edit", component: <CommissionCreate /> },
  { path: "/finance/rules/institutes/:id1/channels/:id2/view", component: <InstituteCommissionList /> },
  { path: "/finance/rules/channels/:id1/institutes/:id2/view", component: <ChannelCommissionList /> },
  { path: "/finance/rules/institutes/:id1/subagents/:id2/view", component: <InstituteSubagentCommissionList /> },
  { path: "/finance/rules/subagents/:id1/institutes/:id2/view", component: <SubagentCommissionList /> },
  { path: "/students/:id/shortlist/:shortlistId", component: <ShortList /> },
  { path: "/disputes", component: <Disputes /> },
  { path: "/payments", component: <Payments /> },
  { path: "/footprints", component: <Audit /> },
  { path: "/footprints/:id", component: <AuditLogContainer /> },
  { path: "/notifications", component: <Notifications /> },
  { path: "/workspace-setting", component: <Workspace />},
  { path: "/marketplace-info", component: <Marketplace />},
  { path: "/integrations/:id/", component: <Marketplace />},
  { path: "/integrations", component: <Integrations />},
  { path: "/integrations/setup/:installationId", component: <LeadCollectionSetup />},
  { path: "/integrations/oauth/callback/:appId", component: <OAuthCallback />},
  { path: "/campaigns", component: <Campaigns /> },
  { path: "/campaigns/:id", component: <CampaignDetails /> },
  { path: "/campaigns/new", component: <CampaignWizard /> },
  { path: "/campaigns/:id/edit", component: <CampaignWizard /> },
];

const publicRoutes = [
  { path: "/signup", component: <Signup /> },
  { path: "/signup/success", component: <SignupSuccess /> },
  { path: "/signup/error", component: <SignupSuccess /> },
  { path: "/Signin", component: <Signin /> },
  { path: "/password/forgot", component: <ForgotPassword /> },
  { path: "/join/:id", component: <Joinuser /> },
  { path: "/password/reset/:id", component: <ResetPassword /> },
  { path: "/recommendations/:tenant/:id", component: <Recommendations /> },
  { path: "/migration-approved", component: <MigrationConfirmation /> },
  { path: "/authority-letter/:accessToken/:applicationId", component: <AuthorizationStudentForm /> },
  { path: "/agent-letter/:tid/:appid", component: <AgentChangeForm /> },
  { path: "/forms/:tenantId/:id", component: <CustomForm /> },
  { path: "/session-expired", component: <SessionError /> },
  { path: "/pricing", component: <PricingModel /> },
  { path: "/my-accounts", component: <MultipleSignin /> },
  { path: "/book-meeting/:tenId/:eventTypeId", component: <MeetingBooking/> },
  { path: "/letterhead", component: <CompanyLetterHeadHeader /> },
];

export { authProtectedRoutes, publicRoutes };
